<template>
<div class="site-footer" style="padding:20px 0;">
   <div class="row">
      <div class="col s12 yo-align-center white">
         <div class="" style="">{{$teras.browser.name}} v. {{$teras.browser.version}} on {{$teras.browser.os}}</div>
         BioMedia srl - Partner della comunità scientifica - All rights Reserved -­ via Libero Temolo 4 ­ torre U8 ­- 20126 Milano ­- P.IVA 10691860158
      </div>
   </div>
</div>
</template>

<script>
export default {
}
</script>

